module.exports = __webpack_public_path__ + "img/kort-28.0df0225e.jpg";